<div class="stock-legend">
  <h1>{{ 'textStock.tableHeaders.table.availableStock' | cxTranslate }}</h1>
  <p>{{ 'textStock.tableHeaders.table.stockAvailability' | cxTranslate }}</p>
  <span class="legend-item stock-disponible">{{ 'textStock.tableHeaders.table.availableStock' | cxTranslate }}</span>
  <span class="legend-item stock-limitado">{{ 'textStock.tableHeaders.table.limitedStock' | cxTranslate }}</span>
  <span class="legend-item sin-stock">{{ 'textStock.tableHeaders.table.noStock' | cxTranslate }}</span>
</div>
<div class="stock-flex-box">
  <div *ngIf="!isAsturias() && (quickStockData | async) as data; else asturiasStore">
    <div class="ui-tabs">
      <div class="row ui-tabs-nav">
        <button *ngFor="let group of data.subcategories; let i = index" class="col-sm-2 js-tab-nav ui-tabs-nav-item"
          [class.active]="selectedCategory === group.id" (click)="getCategoryPosition(group.id)">
          {{ group.name }}
        </button>
      </div>
    </div>

    <div class="sub-ui-tabs" *ngIf="subcategories.length > 0">
      <div class="sub-row sub-ui-tabs-nav">
        <button *ngFor="let subcategory of subcategories; let i = index" class="col-sm-2 js-tab-nav ui-tabs-nav-item"
          [class.active]="selectedSubCategory === subcategory.code" (click)="getProductsPosition(subcategory.code)">
          {{ subcategory.gradeName }}
        </button>
      </div>
    </div>

    <div *ngIf="loading" class="loading-indicator">
      <cx-spinner></cx-spinner>
    </div>
    <div *ngIf="!loading">
      <table class="table">
        <thead>
          <tr>
            <th>{{ 'textStock.tableHeaders.table.thickness' | cxTranslate }}</th>
            <th>{{ 'textStock.tableHeaders.table.ancho' | cxTranslate }}</th>
            <th>{{ 'textStock.tableHeaders.table.largo' | cxTranslate }}</th>
            <th>{{ 'textStock.tableHeaders.table.stockBobinas' | cxTranslate }}</th>
            <th>{{ 'textStock.tableHeaders.table.paquetes2TM' | cxTranslate }}</th>
            <th>{{ 'textStock.tableHeaders.table.paquetes2_5TM' | cxTranslate }}</th>
            <th>{{ 'textStock.tableHeaders.table.paquetes3TM' | cxTranslate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tableData">
            <td *ngIf="row.showCell" [attr.rowspan]="row.rowspan" class="align-middle">{{ row.thickness }}</td>
            <td>{{ row.width }}</td>
            <td>{{ row.length }}</td>
            <td
              [class]="row.stockLevel > 15000 ? 'quickstock-legend-stock': row.stockLevel <= 15000 && row.stockLevel > 0 ? 'quickstock-legend-lowstock': 'quickstock-legend-nostock arrival-notification-quick-stock'"
              [title]="row.stockLevel > 0 ? (row.formattedPrice1_5 + '/Tm') : ''"
              (click)="row.stockLevel > 0 ? openQuickStockModal(row.product_default, row.length, undefined, row.width, row.thickness) : openNotificationModal(row.product_default)"
              [style.cursor]="row.stockLevel > 0 ? 'pointer' : 'default'">{{ formatStockLevel(row.stockLevel) }}</td>
            <td [ngClass]="{
            'quickstock-legend-lowstock': row.stock2_0 > 0,
            'quickstock-legend-nostock': row.stock2_0 === 0
          }" (click)="row.stock2_0 > 0 ? openQuickStockModal(row.product2_0, row.length, '2000', row.width, row.thickness, row.stock2_0) : openNotificationModal(row.product2_0)"
              [style.cursor]="row.stock2_0 > 0 ? 'pointer' : 'default'"
              [title]="row.stock2_0 > 0 ? (row.formattedPrice2_0 + '/Tm') : ''">{{ row.stock2_0 }}
            </td>
            <td [ngClass]="{
            'quickstock-legend-lowstock': row.stock2_5 > 0,
            'quickstock-legend-nostock': row.stock2_5 === 0
          }" (click)="row.stock2_5 > 0 ? openQuickStockModal(row.product2_5, row.length, '2500', row.width, row.thickness, row.stock2_5) : openNotificationModal(row.product2_5)"
              [style.cursor]="row.stock2_5 > 0 ? 'pointer' : 'default'"
              [title]="row.stock2_5 > 0 ? (row.formattedPrice2_5 + '/Tm') : ''">{{ row.stock2_5 }}
            </td>
            <td [ngClass]="{
            'quickstock-legend-lowstock': row.stock3_0 > 0,
            'quickstock-legend-nostock': row.stock3_0 === 0
          }" (click)="row.stock3_0 > 0 ? openQuickStockModal(row.product3_0, row.length, '3000', row.width, row.thickness, row.stock3_0) : openNotificationModal(row.product3_0)"
              [style.cursor]="row.stock3_0 > 0 ? 'pointer' : 'default'"
              [title]="row.stock3_0 > 0 ? (row.formattedPrice3_0 + '/Tm') : ''">{{ row.stock3_0 }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #asturiasStore>
  <div *ngIf="isAsturias()">
    <div class="ui-tabs">
      <div class="ui-tabs-nav row">
        <button class="col-sm-2 js-tab-nav ui-tabs-nav-item" [class.active]="selectedCode === '3030002'"
          (click)="onCategorySelect('3030002')">
          {{ 'textStock.tableHeaders.table.rounds' | cxTranslate }}
        </button>
        <button class="col-sm-2 js-tab-nav ui-tabs-nav-item" [class.active]="selectedCode === '3030003'"
          (click)="onCategorySelect('3030003')">
          {{ 'textStock.tableHeaders.table.squares' | cxTranslate }}
        </button>
        <button class="col-sm-2 js-tab-nav ui-tabs-nav-item" [class.active]="selectedCode === '3030004'"
          (click)="onCategorySelect('3030004')">
          {{ 'textStock.tableHeaders.table.rectangular' | cxTranslate }}
        </button>
        <button class="col-sm-2 js-tab-nav ui-tabs-nav-item" [class.active]="selectedCode === '3030005'"
          (click)="onCategorySelect('3030005')">
          {{ 'textStock.tableHeaders.table.specials' | cxTranslate }}
        </button>
      </div>

      <div class="sub-row sub-ui-tabs-nav asturias-sub-ui" *ngIf="selectedCode !== '3030005'">
        <button class="col-sm-2 js-tab-nav ui-tabs-nav-item" [class.active]="selectedGroup === 'Galvanized'"
          (click)="onProductTypeSelect('Galvanized')">
          {{ 'textStock.tableHeaders.table.galvanized' | cxTranslate }}
        </button>
        <button class="col-sm-2 js-tab-nav ui-tabs-nav-item" [class.active]="selectedGroup === 'Pickled'"
          (click)="onProductTypeSelect('Pickled')">
          {{ 'textStock.tableHeaders.table.pickled' | cxTranslate }}
        </button>
      </div>
      <div *ngIf="loading" class="loading-indicator">
        <cx-spinner></cx-spinner>
      </div>
      <div *ngIf="!loading">
        <table class="table">
          <thead>
            <tr>
              <th>{{ 'textStock.tableHeaders.table.thickness' | cxTranslate }}</th>
              <th *ngIf="selectedCode !== '3030002'">{{ 'textStock.tableHeaders.table.side1' | cxTranslate }}</th>
              <th>{{ 'textStock.tableHeaders.table.side2' | cxTranslate }}</th>
              <th>{{ 'textStock.tableHeaders.table.lenght' | cxTranslate }}</th>
              <th>{{ 'textStock.tableHeaders.table.quality' | cxTranslate }}</th>
              <th *ngIf="selectedCode === '3030005'">{{ 'textStock.tableHeaders.table.specialType' | cxTranslate }}</th>
              <th>{{ 'textStock.tableHeaders.table.group' | cxTranslate }}</th>
              <th>{{ 'textStock.tableHeaders.table.stock' | cxTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of tableDataTubes?.productList">
              <td *ngIf="row.rowspan !== 0" [attr.rowspan]="row.rowspan">{{ row.thickness }}</td>
              <td *ngIf="selectedCode !== '3030002'">{{ row.side1 }}</td>
              <td>{{ row.side2 }}</td>
              <td>{{ row.lenght }}</td>
              <td>{{ row.quality }}</td>
              <td *ngIf="selectedCode === '3030005'">{{ row.specialType }}</td>
              <td>{{ getGroupName(row.group) }}</td>
              <td class="{{row.stockMessage.replaceAll('.', '-')}}"
                [title]="'€' + row.formattedPrice + (isAsturias() ? '/100m.l' : '/100kg')"
                (click)="!row.stockMessage.includes('nostock') ? openQuickStockModal(row) : openNotificationModal(row.fullProduct)">
                {{ row.stockMessage | cxTranslate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>